<script lang="ts">
  import { page } from '$app/state'
  import { getAuthContext } from '$lib/auth-context.svelte'
  import { getSupabaseContext } from '$lib/supabase/context'
  import { selectAccessory } from '$lib/utils/profile'
  import { onDestroy } from 'svelte'
  import RewardReveal from './RewardReveal.svelte'
  import { createRevealQueue } from './reveal-queue.svelte'

  const { newAccessories, newAchievements } = getAuthContext()
  const { supabase } = getSupabaseContext()

  const queue = createRevealQueue({
    accessories: newAccessories,
    achievements: newAchievements,
    markAccessorySeen: (id) => newAccessories.markAsSeen(id),
    markAchievementSeen: (id) => newAchievements.markAsSeen(id),
    equipAccessory: async (accessory) => {
      const profile = page.data.session?.profile
      if (!profile) return
      await selectAccessory(supabase.current, profile.id, accessory)
    },
  })

  onDestroy(() => queue.destroy())
</script>

<RewardReveal {queue} />
